import { createStore } from 'vuex'
import _ from 'lodash'
import 'string_score'

import * as mutationTypes from './mutation-types'

import workflows from './workflows'
import accounts from './accounts'
import companies from './companies'
import reconciliationTexts from './reconciliation-texts'
import createQueryModule from './query'
import ui from './ui'

import { limitSearchResults } from './helpers'

export default function createSearchStore({ currentFirmId, currentCompanyId }) {
  return createStore({
    modules: {
      accounts,
      companies,
      reconciliationTexts,
      workflows,
      query: createQueryModule(),
      ui,
    },

    state: {
      currentFirmId,
      currentCompanyId,
      dataLoaded: false,
      dataLoading: false,
      limit: 4,
    },

    getters: {
      allSearchResults: (
        { dataLoaded },
        {
          processedReconciliationTexts,
          processedAccounts,
          processedCompanies,
          processedWorkflows,
          currentQuery,
        }
      ) => {
        if (!dataLoaded) {
          return []
        } else if (dataLoaded && _.isEmpty(currentQuery)) {
          return [['Workflow', processedWorkflows]]
        }

        return [
          ['Workflow', processedWorkflows],
          ['Company', processedCompanies],
          ['ReconciliationText', processedReconciliationTexts],
          ['Account', processedAccounts],
        ]
      },
      searchResults: (state, { allSearchResults }) => {
        const results = _.map(allSearchResults, (item) =>
          limitSearchResults(item[1], state.limit)
        )

        return _.concat(...results)
      },
      searchResultsByType:
        (state, { searchResults }) =>
        (type) => {
          return _.filter(searchResults, { type })
        },
      extraSearchResultsCountsByType:
        (state, { allSearchResults }) =>
        (type) => {
          for (const item of allSearchResults) {
            if (item[0] === type) {
              return item[1].length - state.limit
            }
          }
        },
    },

    mutations: {
      [mutationTypes.SET_DATA_LOADING](state, dataLoading) {
        state.dataLoading = dataLoading
      },
      [mutationTypes.SET_DATA_LOADED](state) {
        state.dataLoaded = true
      },
      [mutationTypes.SET_LIMIT](state, limit) {
        state.limit = limit
      },
    },

    actions: {
      fetchSearchData({ commit, state }) {
        commit(mutationTypes.SET_DATA_LOADING, true)

        window.$.ajax({
          url: Silverfin.Routes.quick_search_path({
            firm_id: state.currentFirmId,
            company_id: state.currentCompanyId,
          }),
          success: (items) => {
            commit(mutationTypes.SET_DATA_LOADING, false)
            commit(mutationTypes.SET_DATA_LOADED)
            commit(mutationTypes.SET_COMPANIES_DATA, items.companies)
            commit(mutationTypes.SET_ACCOUNTS_DATA, items.accounts)
            commit(
              mutationTypes.SET_RECONCILIATION_TEXTS_DATA,
              items.reconciliationTexts
            )
            commit(mutationTypes.SET_WORKFLOWS_DATA, items.workflows)
          },
        })
      },
      setResultLimit({ commit }, payload) {
        commit(mutationTypes.SET_LIMIT, payload)
      },
    },
  })
}
